module.exports = "## Divider\n\n[Dividers](https://www.google.com/design/spec/components/dividers.html) group and separate content within lists and page layouts. The divider is a thin rule, lightweight yet sufficient to distinguish content visually and spatially.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Divider/README.md
 ** module id = 973
 ** module chunks = 0
 **/